export const cleanUndefined = obj => {
	const newObj = {};

	Object.keys(obj).forEach(key => {
		if (obj[key] && typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
			newObj[key] = cleanUndefined(obj[key]); // recurse
		} else if (obj[key] !== undefined && obj[key] !== null) {
			newObj[key] = obj[key]; // copy value
		}
	});

	return newObj;
};
